var sw = require('js/lib/sw');

module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-finish-selector]').each(function () {
    var modelId = $(this).attr('data-sw-model-material-configurator-finish-selector');
    var el = this;
    require(
      [
        'vue',
        'vuex',
        'rrViewComponents/Model/MaterialConfigurator/sw-model-material-configurator-module',
        'rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorFinishSelectorComponent/tpl.model-material-configurator-finish-selector-vue.mustache'
      ], function (vue, vuex, modelMaterialConfiguratorModule, tpl) {

      new vue({
        el: el,
        data: {
          modelId: modelId
        },
        template: tpl.render(),
        store: modelMaterialConfiguratorModule,
        updated: function () {
          /**
           * In order to have mixpanel autohandling work
           * with vue we just call fragment loaded
           */
          this.$nextTick(function () {
            sw.trigger('sw-fragment-loaded', $(this.$el));
          });
        },
        computed: vuex.mapState({
          materialFinishOptions: function (state) {
            return state[this.modelId].materialFinishOptions;
          },
          hasFinishSelected: function (state) {
            return state[this.modelId].hasFinishSelected;
          },
          isSelectedFinish: function (state) {
            return function (finishId) {
              return state[this.modelId].selectedMaterialFinishId === finishId;
            }
          },
          isLoading: function(state) {
              return state[this.modelId].isLoading;
          }
        }),
        methods: {
          selectFinish: function (finishId) {
            modelMaterialConfiguratorModule.dispatch('modelMaterialConfigurator/updateChoice', {
              modelId: this.modelId,
              hasFinishSelected: true,
              selectedMaterialFinishId: finishId,
              selected: 'finish'
            });
          }
        }
      });
    });
  });
};
